import {
  unwrap,
  type PortalCompanyDetails,
  type UpdatePortalCompanyDetails,
} from '@billda/api';
import { api } from '../../../shared/api/billdaApi';

export type CompanyDetailsResponse = PortalCompanyDetails;
export type UpsertCompanyDetailsRequest = UpdatePortalCompanyDetails;

export async function getCompanyDetails(
  signal?: AbortSignal
): Promise<CompanyDetailsResponse> {
  return unwrap(
    await api.portalGateway.GET('/portal/v1/company-profile', { signal })
  );
}

export async function upsertCompanyDetails(
  request: UpsertCompanyDetailsRequest
): Promise<CompanyDetailsResponse> {
  return unwrap(
    await api.portalGateway.PUT('/portal/v1/company-profile', {
      body: request,
    })
  );
}
